import './Fem.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Dropdown from 'react-bootstrap/Dropdown'
import React, { useEffect, useState, useRef } from 'react' //
import { damGL, deformFunc, setInteractionMode } from './damGL'
import doRequest from '../../../requests/requests'
import { GetDeslocamentosHor, GetDeslocamentosVer, GetModDeslocamentos, RenderLegend } from './plot';
import { DraggableModalDialog } from '../DraggableModalDialog';
import { Resizable } from "re-resizable"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { BsWindow } from "react-icons/bs";
import { BsWindowStack } from "react-icons/bs";



function Fem({ fem, unsetFem, children }) {
    const originalLink = fem?.links?.find((link) => link?.rel.includes('original'))?.href
    const [mode, setMode] = useState({
        mode: 'Base',
        material: fem.properties.pFem.material,
        interaction: 1
    })
    const [interaction, setInteraction] = useState(1)
    const [sliderValue, setSliderValue] = useState(1)

    const download = () => {
        doRequest({ onProgress: undefined, uri: originalLink, method: 'GET' }).then(
            async (res) => {
                if (res.status === 200) {
                    const file = URL.createObjectURL(await res.blob())
                    let a = document.createElement('a')
                    a.download = fem.properties.name
                    a.href = file
                    a.click()
                }
            }
        )
    }

    useEffect(() => {
        if (deformFunc !== undefined) {
            deformFunc(sliderValue)
        }

    }, [sliderValue])

    let dispMod = [];
    let dispHor = [];
    let dispVer = [];
    if (mode.mode !== 'Base' && mode.mode !== 'Modo 1' && mode.mode !== 'Modo 2' && mode.mode !== 'Modo 3') {
        dispMod = GetModDeslocamentos(mode.deformationArray);
        dispHor = GetDeslocamentosHor(mode.deformationArray);
        dispVer = GetDeslocamentosVer(mode.deformationArray);
    }

    const [displacementMode, setDisplacementMode] = useState('modulus')
    const [dispIndex, setDispIndex] = useState(0)
    const [displacementArray, setDisplacementArray] = useState(dispMod)
    const [displacementUnits, setUnits] = useState('|u|')
    const [displacementColorArrays, setColorArrays] = useState({ mod: [], hor: [], ver: [] })
    const [refreshClicked, setRefreshClicked] = useState(false);


    useEffect(() => {
        if (mode.mode !== 'Base') {
            if (displacementMode === 'modulus') {
                setDispIndex(0);
                setDisplacementArray(dispMod);
                setUnits('|u|');
                mode.colorArray = displacementColorArrays.mod;

            } else if (displacementMode === 'horizontal') {
                setDispIndex(1);
                setDisplacementArray(dispHor);
                setUnits('|ux|');
                mode.colorArray = displacementColorArrays.hor;

            } else if (displacementMode === 'vertical') {
                setDispIndex(2);
                setDisplacementArray(dispVer);
                setUnits('|uz|');
                mode.colorArray = displacementColorArrays.ver;

            }
        }

        damGL('damCanvas', fem.properties.pFem.vertices, fem.properties.pFem.indices, mode.material, mode.colorArray, mode.deformationArray, fem.properties.pFem.height, mode.deformScale, fem.properties.pFem.numDamMats)
        setRefreshClicked(false);
    }, [displacementMode, mode, refreshClicked])


    const handleRadioChange = (event) => {
        setDisplacementMode(event.target.value);
        setSliderValue(1)
    };

    const handleRefreshClick = () => {
        setRefreshClicked(true);
    };

    const [canvasWidth, setCanvasWidth] = useState(700);
    const [canvasHeight, setCanvasHeight] = useState(510);

    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
    /*  used to remove dragability for small resolutions */
    const modalDialog = window.innerWidth > 768 ? DraggableModalDialog : undefined;

    const [isFullScreen, setIsFullScreen] = useState(false);

    const defaultModalWidth = 966;
    const defaultModalHeight = 754;

    const toggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
        if (!isFullScreen) {
            // Update size of resizable component when fullscreen mode
            // update only the height or the width depending on the larger value
            const maxWidth = Math.max(defaultModalWidth, window.innerWidth);
            const maxHeight = Math.max(defaultModalHeight, window.innerHeight);

            /* if (maxWidth > maxHeight) {
                updateResizableSize(maxWidth, 'auto');
            } else {
                updateResizableSize('auto', maxHeight);
            } */

            updateResizableSize(window.innerWidth, window.innerHeight);
            /* setCanvasHeight(250) */

        } else {
            // Set the default size when not fullscreen
            updateResizableSize(defaultModalWidth, defaultModalHeight);
            /*  setCanvasHeight(510) */
        }
    };

    const resizableRef = useRef(null);

    const updateResizableSize = (width, height) => {
        if (resizableRef.current) {
            resizableRef.current.updateSize({ width, height });
        }
    };



    return (
        <Modal show={fem !== undefined} className='femmodal' onHide={() => unsetFem()} centered dialogAs={modalDialog} backdrop={'static'} style={{ height: '100vh' }}>
            <Resizable
                ref={resizableRef} // Assign the ref to the resizable component
                className="modal-resizable"
                size={{ defaultModalWidth, defaultModalHeight }}
                /*  lockAspectRatio={true} */
                enable={!isFullScreen ? { top: true, right: true, bottom: true, left: true } : false}
            >
                <ModalHeader className="modal-header fem-header" closeButton>
                    <Modal.Title>{fem.properties.name}</Modal.Title>
                    {isDesktop &&
                        <button className='btn-maximize ' onClick={toggleFullScreen} /* style={{background:'none',border:'none', verfontSize:'1.5em', color:'#808080', marginLeft:'auto'}} */>
                            {isFullScreen ? <BsWindowStack /> : <BsWindow />}
                        </button>}


                </ModalHeader>
                <ModalBody style={{ height: '100%' }}>
                    <Container fluid style={{ height: '100%' }}>
                        <Row className='fem-row-contents'>
                            <Col xs='12' sm='3' md='3' className='side-col'>
                                <Row>
                                    <Button active={mode.mode === 'Base'} variant="outline-primary" onClick={() => {
                                        setInteraction(1)
                                        setSliderValue(1)
                                        setMode({
                                            mode: 'Base',
                                            material: fem.properties.pFem.material
                                        })
                                    }}>FEM</Button>
                                </Row>
                                <Row>
                                    {/*  {
                                    fem.properties.pFem.sims_static?.length > 0 && <span>Static Response: </span>
                                } */}
                                    {fem.properties.pFem.sims_static?.length > 0 &&
                                        <Dropdown className='dropdown'>
                                            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
                                                Static Response
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='dropdown-menu'>
                                                {
                                                    fem.properties.pFem.sims_static?.map((sim) => {
                                                        return (
                                                            <Dropdown.Item active={mode.mode === sim.name}
                                                                onClick={() => {
                                                                    setInteraction(1)
                                                                    setSliderValue(1)
                                                                    setMode({
                                                                        mode: sim.name,
                                                                        deformationArray: sim.forces,
                                                                        colorArray: sim.colors[dispIndex],
                                                                        deformScale: sim.maxDistance[0],
                                                                    })
                                                                    setColorArrays({
                                                                        mod: sim.colors[0],
                                                                        hor: sim.colors[1],
                                                                        ver: sim.colors[2]
                                                                    })

                                                                }}>
                                                                {sim.name}
                                                            </Dropdown.Item>)
                                                    })
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }
                                </Row>
                                <Row>
                                    {fem.properties.pFem.sims_seismic?.length > 0 &&
                                        <Dropdown className='dropdown'>
                                            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
                                                Seismic Response
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='dropdown-menu'>
                                                {
                                                    fem.properties.pFem.sims_seismic?.map((sim) => {
                                                        return (
                                                            <Dropdown.Item active={mode.mode === sim.name}
                                                                onClick={() => {
                                                                    setInteraction(1)
                                                                    setSliderValue(1)
                                                                    setMode({
                                                                        mode: sim.name,
                                                                        deformationArray: sim.forces,
                                                                        colorArray: sim.colors[dispIndex],
                                                                        deformScale: sim.maxDistance[0]
                                                                    })
                                                                    setColorArrays({
                                                                        mod: sim.colors[0],
                                                                        hor: sim.colors[1],
                                                                        ver: sim.colors[2]
                                                                    })

                                                                }}>
                                                                {sim.name}
                                                            </Dropdown.Item>)
                                                    })
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }
                                </Row>
                                <Row>
                                    {fem.properties.pFem.sims_vibration?.length > 0 &&
                                        <Dropdown className='dropdown'>
                                            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
                                                Vibration Modes
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='dropdown-menu'>
                                                {
                                                    fem.properties.pFem.sims_vibration?.map((sim) => {
                                                        return (
                                                            <Dropdown.Item active={mode.mode === sim.name}
                                                                onClick={() => {
                                                                    setInteraction(1)
                                                                    setSliderValue(1)
                                                                    setMode({
                                                                        mode: sim.name,
                                                                        fn: sim.fn,
                                                                        deformationArray: sim.forces,
                                                                        colorArray: sim.colors[dispIndex],
                                                                        deformScale: sim.maxDistance[0]
                                                                    })
                                                                    setColorArrays({
                                                                        mod: sim.colors[0],
                                                                        hor: sim.colors[1],
                                                                        ver: sim.colors[2]
                                                                    })

                                                                }}>
                                                                {sim.name}
                                                            </Dropdown.Item>)
                                                    })
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }
                                </Row>

                                {(mode.mode !== 'Base'/* mode.mode == 'Peso próprio' || mode.mode == 'Pressão Hidrostática. Cota 280'|| mode.mode == 'Instante TJ'|| mode.mode == 'Instante TM' */) &&
                                    <Row>
                                        <FormControl variant="standard" id='radio-form'>
                                            <FormLabel id="displacement-radios">Displacement Type</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="displacement-radios"
                                                defaultValue="modulus"
                                                value={displacementMode}
                                                onChange={handleRadioChange}
                                            >
                                                <FormControlLabel value="modulus" control={<Radio />}
                                                    label="Displacement Modulus" />
                                                <FormControlLabel value="horizontal" control={<Radio />}
                                                    label="Horizontal Displacement" />
                                                <FormControlLabel value="vertical" control={<Radio />}
                                                    label="Vertical Displacement" />
                                            </RadioGroup>
                                        </FormControl>


                                    </Row>
                                }
                                {/* disabled radios for base mode */}
                                {(mode.mode === 'Base') &&
                                    <Row>
                                        <FormControl variant="standard" id='radio-form'>
                                            <FormLabel id="displacement-radios">Displacement Type</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="displacement-radios"
                                                defaultValue="modulus"
                                                value={displacementMode}
                                                onChange={handleRadioChange}
                                            >
                                                <FormControlLabel value="modulus" disabled control={<Radio />}
                                                    label="Displacement Modulus" />
                                                <FormControlLabel value="horizontal" disabled control={<Radio />}
                                                    label="Horizontal Displacement" />
                                                <FormControlLabel value="vertical" disabled control={<Radio />}
                                                    label="Vertical Displacement" />
                                            </RadioGroup>
                                        </FormControl>


                                    </Row>
                                }


                            </Col>
                            <Col className='main-col' style={{ height: '100%' }}>
                                <span
                                    className='mode'
                                    style={{
                                        width: isFullScreen ? '65%' : '90%',
                                        transform: isFullScreen ? 'translateX(13em)' : 'translateX(1.5em)',
                                    }}>
                                    FEM - {mode.mode}
                                    {mode.fn ? `, fn = ${mode.fn} Hz` : ''}
                                </span>
                                <Row className='canvas-container' style={{ height: isFullScreen ? '80%' : 'auto' }}>
                                    <canvas id='damCanvas' className='canvas' width={canvasWidth} height={canvasHeight}></canvas>
                                </Row>
                                <Row>
                                    <ButtonGroup>
                                        <Button name='interaction' active={interaction == 1} onClick={() => {
                                            setInteraction(1)
                                            setInteractionMode(1)
                                        }} variant="outline-primary">Rotate</Button>
                                        <Button name='interaction' active={interaction == 2} onClick={() => {
                                            setInteraction(2)
                                            setInteractionMode(2)
                                        }} variant="outline-primary">Pan</Button>
                                        <Button name='interaction' active={interaction == 3} onClick={() => {
                                            setInteraction(3)
                                            setInteractionMode(3)
                                        }} variant="outline-primary">Zoom</Button>
                                        <Button name='interaction' onClick={() => {
                                            handleRefreshClick()
                                        }} variant="outline-primary">Reset</Button>

                                        {/* {isDesktop &&
                                        <Button onClick={toggleFullScreen}>
                                            {isFullScreen ? 'Exit Maximize' : 'Maximize'}
                                        </Button>} */}

                                    </ButtonGroup>
                                    {(mode.mode !== 'Mode 1' && mode.mode !== 'Mode 2' && mode.mode !== 'Mode 3' && mode.mode !== 'Base'
                                        && mode.mode !== 'Modo 1' && mode.mode !== 'Modo 2' && mode.mode !== 'Modo 3') &&
                                        <><span id="slider-title">Amplification Factor</span>
                                            <input
                                                type={"range"}
                                                min={0}
                                                max={1000}
                                                value={sliderValue}
                                                className={"slider"}
                                                id={"myRange"}
                                                onChange={(event) => {
                                                    setSliderValue(event.currentTarget.value)
                                                }}
                                            /></>
                                    }
                                </Row>
                                <Row>
                                    {(mode.mode === 'Mode 1' || mode.mode === 'Mode 2' || mode.mode === 'Mode 3' ||
                                        mode.mode === 'Modo 1' || mode.mode === 'Modo 2' || mode.mode === 'Modo 3') &&
                                        <><span id="slider-title">Amplification Factor</span>
                                            <input
                                                type={"range"}
                                                min={-500}
                                                max={500}
                                                value={sliderValue}
                                                className={"slider"}
                                                id={"myRange"}
                                                onChange={(event) => {
                                                    setSliderValue(event.currentTarget.value)
                                                }}
                                            /></>
                                    }
                                    {mode.mode == 'Base' &&
                                        <div id='slider-empty'></div>
                                    }
                                </Row>

                            </Col>
                            {(mode.mode !== 'Base' && mode.mode !== 'Mode 1' && mode.mode !== 'Mode 2' && mode.mode !== 'Mode 3' &&
                                mode.mode !== 'Modo 1' && mode.mode !== 'Modo 2' && mode.mode !== 'Modo 3' && displacementArray.length > 0) &&
                                <Col xs='1' sm='1' md='1' className='col-color'>

                                    {RenderLegend(displacementArray, displacementUnits, '(mm)')}
                                </Col>

                            }
                        </Row>
                    </Container>
                </ModalBody>
                <ModalFooter className='fem-modal-footer'>
                    {originalLink && <Button onClick={() => download()}>Download</Button>}
                    {children}
                </ModalFooter>
            </Resizable>
        </Modal>
    )
}

export default Fem
